import { useEffect, useState } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import LineChart from "./dashboard-charts/lineCahrt";

import db from "../../../db/index.json";

const PropertyRegister = ({ Stats }) => {
  const { rightPanel } = db;
  // const chartData = [5, 10, 35, 20];
  // const categories = ["Week 1", "Week 2", "Week 3", "Week 4"];

  const [chartData, setChartData] = useState([0, 0, 0, 0]);
  const [categories, setCategories] = useState([
    "Week 1",
    "Week 2",
    "Week 3",
    "Week 4",
  ]);

  useEffect(() => {
    if (Stats) {
      setChartData(Stats?.propertyStats?.count);
      setCategories(Stats?.propertyStats?.duration);
    }
  }, [Stats]);
  return (
    <div className="bg-white rounded-2xl py-5 px-4 w-full mt-5 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
      <div className="">
        <ParagraphTag
          content={rightPanel.register}
          classes="text-darkColor font-popinsSemiBold text-base"
        />

        <ParagraphTag
          content={`Total properties registered: ${Stats?.allProperties}`}
          classes="text-darkColor font-popinsSemiBold text-sm pt-4"
        />
      </div>
      <div className="mt-4">
        <LineChart
          categories={categories}
          data={chartData}
          title="Custom Chart Title"
        />
      </div>
    </div>
  );
};

export default PropertyRegister;
